// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {orderBy} from 'lodash';

// Components
import Error from '../core/error';
import Loading from '../core/loading';
import RecordDetails from '../core/record-details';
import SearchPagination from '../app/search-pagination';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './mediaitem-failures.scss';

const servicesDataKey = 'violationsRelated';

class MediaItemViolations extends Component {
    getPaginationProps() {
        return {
            maxResults: 50000,
            maxPages: 9,
        };
    }

    getRecordDetailsProps() {
        return {
            className: 'mediaitem-failures--record-details',
            whitelistKeys: [
                'violationId',
                'category',
                'statusCode',
                'rule',
                'reason',
                'dateCreated',
                'lastUpdated',
                'lastModifiedBy',
                'idFromPartner',
                'provider',
                'network',
                'mediaItemTitle',
            ],
        };
    }

    renderFailures() {
        const {searchData: searchDataProp} = this.props;
        const searchData = orderBy(searchDataProp, ['lastUpdated'], ['desc']);
        const content = searchData.map((dataRow, key) => (
            <div className="mediaitem-failures--record" key={key}>
                <RecordDetails {...this.getRecordDetailsProps()} searchData={[dataRow]} />
            </div>
        ));
        return content;
    }

    render() {
        const {error, fetching, searchData} = this.props;
        const failures = !fetching ? this.renderFailures() : [];

        return searchData ? (
            <div className="mediaitem-failures">
                <div className="mediaitem-failures--content">
                    <Error error={error} />
                    <SearchPagination {...this.getPaginationProps()} />
                    {failures.length > 0 || fetching ? (
                        failures
                    ) : (
                        <div className="mediaitem-failures--no-items">No violations to display</div>
                    )}
                    <Loading loading={fetching} />
                </div>
            </div>
        ) : (
            <Error error="Choose a record." />
        );
    }
}

MediaItemViolations.propTypes = {
    error: PropTypes.string,
    fetching: PropTypes.bool,
    routerParams: PropTypes.object.isRequired,
    searchData: PropTypes.array.isRequired,
};

export default withSearch(MediaItemViolations, servicesDataKey);
